import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import { Skeleton } from "../../Skeleton";
import { cn } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
export var TableAvatar = function TableAvatar(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("img", _objectSpread({
    className: cn('tw-h-3.2 tw-w-3.2 tw-shrink-0 tw-rounded-full tw-object-cover', className)
  }, props));
};
export var TableAvatarSkeleton = function TableAvatarSkeleton(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/_jsx(Skeleton, {
    className: cn('tw-w-3.2 tw-h-3.2 tw-rounded-full', className)
  });
};